export const print = (subject: string, data: any) => {
  // eslint-disable-next-line no-console
  console.log(subject, data);
};
